import ProductReview from './ProductReview';
export default ProductReview;
